module.exports = __webpack_public_path__ + "img/orlando-pirates-logo-icon.1b1c9050.png";